var initMarkerMap = function(marker, backControl, roadStartKm, location) {

    const roadStart = roadStartKm ? roadStartKm * 1e3 : 0;

    const latitude = $("#Lat").val() && $("#Lat").val() !== "undefined" ? $("#Lat").val().replace(",", ".") : null;
    const longitude = $("#Lng").val() && $("#Lng").val() !== "undefined" ? $("#Lng").val().replace(",", ".") : null;

    const initLat = latitude != null ? latitude : AppConfig.defaultMapCenter[0];
    const initLng = longitude != null ? longitude : AppConfig.defaultMapCenter[1];

    L.Icon.Default.imagePath = AppConfig.imagePath;
    const grayscale = L.tileLayer(MapSettings.urlFormat,
        { attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' });

    var roadPoints = [];

    var mymap = L.map("marker-map",
        {
            center: [initLat, initLng],
            zoom: AppConfig.defaultMapZoom,
            maxBounds: L.latLngBounds(AppConfig.defaultMapBounds[0], AppConfig.defaultMapBounds[1]),
            minZoom: AppConfig.defaultMapMinZoom,
            zoomReverse: true,
            layers: [grayscale]
        });

    var data = {
        point: null,
        location: roadStart,
        marker: null,
        edgeIndex: 0,
        map: mymap
    };

    if (roadCurrentCoordinates.length && roadCurrentCoordinates[0].length > 1) {
        roadPoints = MapHelper.convertToLatLng(roadCurrentCoordinates);
        const roadsLine = new L.Polyline(roadPoints,
            {
                color: "blue",
                weight: 5,
                opacity: 0.5,
                smoothFactor: 1
            });
        roadsLine.addTo(mymap);

        if (location * 1e3 < roadStart)
            location = roadStart / 1e3;
        if (location != null && !isNaN(location)) {
            let point = null;
            point = MapHelper.findPositionByDistance(location * 1e3 - roadStart, roadPoints).point;
            initPoint(point);
        }

        roadsLine.on("click",
            function(e) {
                const point = e.latlng;
                setPoint(point);
            });

        backControl.on("click",
            function() {
                data.point = null;
                if (data.marker != null) {
                    mymap.removeLayer(data.marker);
                    data.marker = null;
                }
            });
    }

    function initPoint(point) {

        data.point = point;
        data.location = location * 1e3;

        if (data.marker != null) {
            mymap.removeLayer(data.marker);
        }

        data.marker = L.marker(point).addTo(mymap);
    }

    function setPoint(point) {

        const findResult = MapHelper.findPosition(point, roadPoints, MapHelper.getZoom(mymap).coefficient);
        if (findResult.index == null) return;
        if (findResult.deviation > 1.1) return;

        data.point = point;
        data.location = findResult.distance + roadStart;

        if (data.marker != null) {
            mymap.removeLayer(data.marker);
        }

        data.marker = L.marker(point).addTo(mymap);
    }

    return data;
};